export const getCurrencyChar = (currency: string | undefined) => {
  const currencyRecord: Record<string, string> = {
    'RUB': '₽',
    'EUR': '€',
    'GBP': '£',
    'USD': '$',
  }

  return currencyRecord[currency || ''] || '';
}